/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Loading"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enCA = Object.assign(TranslationProviderComponent, {
  translations
});

export { enCA as e };
//# sourceMappingURL=en-CA-Bx92S5U4.js.map
